import * as types from "../types";
import { requestAuth } from "../../helpers/FetchApi";
import appSettings from "../../AppSettings";
import { ActionsCreators } from "..";
import { toast } from "react-toastify";
import strings from "../../helpers/Localization";

export const actionCreators = {
    GetCategoriesList: (pageNumber, pageSize, sortExpression, filterExpression, tagSearchRequest, PaginationType, onSuccess) => async (dispatch, store) => {
        dispatch({ type: types.GET_CALLCATEGORIES_COMPLETED, payload: null });
        if (pageSize < 0) {return onSuccess(null);}
        await requestAuth(appSettings.SKALINKAPIURL + "/api/CallCategories/OrganizationCallCategories/" + store().currentuser.currentorganization.id + "?"
                + "pageNumber=" + pageNumber
                + "&pageSize=" + pageSize
                + (sortExpression ? "&sortExpression=" + sortExpression : "")
                + (filterExpression ? "&filterExpression=" + filterExpression : "")
        , {
            method: "GET"
        }).then((data) => {
            data.sortExpression = sortExpression;
            data.filterExpression = filterExpression;
            data.tagSearchRequest = tagSearchRequest;
            data.PaginationType = PaginationType;
            dispatch({ type: types.GET_CALLCATEGORIES_COMPLETED, payload: data });
            return onSuccess(data);
        }).catch( (data) => {
            console.log(data);
        });
    },
    SaveCategoriesPagination: (paginationType) => (dispatch, store) => {
        const data = store().administration.callcategories;
        dispatch({ type: types.GET_CALLCATEGORIES_COMPLETED, payload: { ...data, PaginationType: paginationType } });
    },
    GetSecondaryCategoriesList: (zoneId, onSuccess) => async (dispatch, store) => {
        await requestAuth(appSettings.SKALINKAPIURL + "/api/CallCategories/AllOrganizationCallCategories/" + store().currentuser.currentorganization.id + "/" + zoneId,
            {
                method: "GET"
            }).then((data) => {
            if (onSuccess) {onSuccess({ results: data });}
            return;
        }).catch( (data) => {
            console.log(data);
        });
    },

    DeleteCallCategory: (categoryId, onSuccess) => async (dispatch, store) => {

        await requestAuth(appSettings.SKALINKAPIURL + "/api/CallCategories/" + categoryId, {
            method: "DELETE"
        }).then((data) => {
            toast.success(strings.CallCategoriesDeleted);
            return onSuccess(data);
        }).catch( (data) => {
            console.log("error", data);
        });
    },

    EditCallCategory: (changedCategory, onSuccess) => async (dispatch, store) => {

        await requestAuth(appSettings.SKALINKAPIURL + "/api/CallCategories/" + changedCategory.id, {
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify(changedCategory),
            method: "PUT"
        }).then((data) => {
            toast.success(strings.CallCategoriesEdited);
            return onSuccess(data);
        }).catch( (data) => {
            console.log("error", data);
        });

    },

    CreateCallCategory: (newCategory, onSuccess) => async (dispatch, store) => {

        await requestAuth(appSettings.SKALINKAPIURL + "/api/CallCategories", {
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify(newCategory),
            method: "POST"
        }).then((data) => {
            toast.success(strings.CallCategoriesCreated);
            return onSuccess(data);
        }).catch( (data) => {
            console.log("error", data);
        });
    }

};
